var exports = {
  "title": "x43cbe9c2--36082c--title",
  "container": "x43cbe9c2--36082c--container",
  "wrapper": "x43cbe9c2--36082c--wrapper",
  "textblock": "x43cbe9c2--36082c--textblock",
  "description": "x43cbe9c2--36082c--description",
  "image": "x43cbe9c2--36082c--image",
  "tablet": "x43cbe9c2--36082c--tablet",
  "phone": "x43cbe9c2--36082c--phone",
  "sale": "x43cbe9c2--36082c--sale",
  "rent": "x43cbe9c2--36082c--rent",
  "host": "x43cbe9c2--36082c--host",
  "apartment": "x43cbe9c2--36082c--apartment",
  "suburban": "x43cbe9c2--36082c--suburban",
};

module.exports = exports;
